import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-900 flex flex-col sm:justify-start md:justify-start lg:justify-start pt-4 sm:pt-8 md:pt-12 sm:px-6 lg:px-8 overflow-y-auto" }
const _hoisted_2 = {
  key: 0,
  class: "sm:mx-auto sm:w-full sm:max-w-md"
}
const _hoisted_3 = { class: "bg-gray-800 py-8 px-6 shadow-md sm:rounded-lg sm:px-10 border border-gray-700" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-gray-400 mb-4" }
const _hoisted_6 = { class: "text-sm text-gray-500 mb-6" }
const _hoisted_7 = { class: "text-white" }
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "sm:mx-auto sm:w-full sm:max-w-xl lg:max-w-2xl" }
const _hoisted_12 = { class: "mt-2 text-center text-sm text-gray-400" }
const _hoisted_13 = { class: "mt-3 sm:mx-auto sm:w-full sm:max-w-md md:max-w-lg lg:max-w-xl" }
const _hoisted_14 = { class: "bg-gray-800 py-6 px-4 sm:rounded-lg sm:px-8" }
const _hoisted_15 = { class: "mt-6 pt-4 border-t border-gray-700" }
const _hoisted_16 = { class: "flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-4" }
const _hoisted_17 = { class: "mt-auto py-6" }
const _hoisted_18 = { class: "max-w-md mx-auto text-center" }
const _hoisted_19 = { class: "flex justify-center items-center space-x-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_RegisterForm = _resolveComponent("RegisterForm")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.registrationSuccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-green-400 text-6xl mb-4" }, "📧", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-2xl font-extrabold text-white mb-2" }, " Registracija uspešna! ", -1)),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.registrationMessage), 1),
              _createElementVNode("p", _hoisted_6, [
                _cache[2] || (_cache[2] = _createTextVNode(" Proverite vašu email adresu ")),
                _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.userEmail), 1),
                _cache[3] || (_cache[3] = _createTextVNode(" i kliknite na link za verifikaciju da biste aktivirali vaš nalog. "))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bg-blue-900 border border-blue-700 text-blue-300 px-3 py-2 rounded text-sm" }, [
                  _createElementVNode("p", { class: "mb-2" }, [
                    _createTextVNode("💡 "),
                    _createElementVNode("strong", null, "Saveti:")
                  ]),
                  _createElementVNode("ul", { class: "text-left text-xs space-y-1" }, [
                    _createElementVNode("li", null, "• Proverite i spam/junk folder"),
                    _createElementVNode("li", null, "• Email može da stigne za nekoliko minuta"),
                    _createElementVNode("li", null, "• Link za verifikaciju važi 24 sata")
                  ])
                ], -1)),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resendVerification && _ctx.resendVerification(...args))),
                  disabled: _ctx.resendingVerification,
                  class: "w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 disabled:opacity-50"
                }, _toDisplayString(_ctx.resendingVerification ? 'Šalje se...' : 'Pošaljite ponovo'), 9, _hoisted_9),
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "block w-full bg-gray-600 text-white px-4 py-2 rounded-md hover:bg-gray-700 text-center"
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" Idite na prijavu ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-center text-2xl md:text-3xl font-extrabold text-white px-10" }, " Kreiraj novi nalog ", -1)),
            _createElementVNode("p", _hoisted_12, [
              _cache[9] || (_cache[9] = _createTextVNode(" Ili ")),
              _createVNode(_component_router_link, {
                to: "/login",
                class: "font-medium text-indigo-400 hover:text-indigo-300"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode(" prijavi se ako već imaš nalog ")
                ])),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_RegisterForm, {
                onRegisterSuccess: _ctx.onRegisterSuccess,
                onShowToast: _ctx.handleShowToast
              }, null, 8, ["onRegisterSuccess", "onShowToast"]),
              _createElementVNode("div", _hoisted_15, [
                _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-gray-400 text-center mb-3" }, " Registracijom se slažete sa našom politikom privatnosti ", -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_router_link, {
                    to: "/privacy-policy",
                    class: "text-xs text-indigo-400 hover:text-indigo-300 underline"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode(" 📄 Politika privatnosti ")
                    ])),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_router_link, {
            to: "/privacy-policy",
            class: "text-xs text-gray-500 hover:text-gray-400 transition-colors"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode(" Privatnost ")
            ])),
            _: 1
          }),
          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-gray-600" }, "•", -1)),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "text-xs text-gray-500 hover:text-gray-400 transition-colors"
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode(" Kontakt ")
            ])),
            _: 1
          })
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs text-gray-600 mt-2" }, " © 2025 Moja Garderoba. Sva prava zadržana. ", -1))
      ])
    ]),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      title: _ctx.toast.title,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type", "title"])
  ]))
}